import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

export interface HousingTenureRecord {
  Place: string;
  place_fips: string;
  year: string | number;
  total_units_built_all_time: number;
  units_built_2014_or_later: number;
  units_built_between_2010_and_2013: number;
  units_built_between_2000_and_2009: number;
  units_built_between_1990_and_1999: number;
  units_built_between_1980_and_1989: number;
  units_built_between_1970_and_1979: number;
  units_built_between_1960_and_1969: number;
  units_built_between_1950_and_1959: number;
  units_built_between_1940_and_1949: number;
  units_built_1939_or_earlier: number;
}

export function useHousingTenureData(place: string | null, placeFips: string | null) {
  const [data, setData] = useState<HousingTenureRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!place || !placeFips) {
      setLoading(false);
      setData([]);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    supabase
      .from('acs_bps_metrics_housing_tenure')
      .select('*')
      .eq('Place', place)
      .eq('place_fips', placeFips)
      .order('year', { ascending: false }) // Get the most recent year first
      .limit(1) // We only need the latest data for this chart
      .then(({ data: supabaseData, error: supabaseError }) => {
        if (supabaseError) {
          console.error('Error fetching housing tenure data:', supabaseError);
          setError(supabaseError.message);
          setData([]);
        } else {
          setData(supabaseData || []);
          // Log the latest record for the selected city
          const latest = (supabaseData || []).slice(-1)[0];
          if (latest) {
            console.log(`Selected City: ${latest.Place}`);
            console.log(`  FIPS: ${latest.place_fips}`);
            console.log(`  Year: ${latest.year}`);
          }
        }
        setLoading(false);
      });
  }, [place, placeFips]);

  return { data, loading, error };
} 